// extracted by mini-css-extract-plugin
module.exports = {"form":"ExportSsoModal__form--2pMUf","confirm":"ExportSsoModal__confirm--2pCu1","notes":"ExportSsoModal__notes--2--O6","wrap":"ExportSsoModal__wrap--zUr0v"};